import React from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import ExploreMoreTierUpsell from './ExploreMoreTierUpsell';
import WantToSellTierUpsell from './WantToSellTierUpsell';
import WantMoreSubscribersTierUpsell from './WantMoreSubscribersTierUpsell';
export var TierUpsell = function (_a) {
    var _b;
    var className = _a.className, deviation = _a.deviation;
    var _c = useSubscriptionTier(deviation), tier = _c.tier, isOwner = _c.isOwner, isUserSubscribed = _c.isUserSubscribed;
    var member_subscriptions = useFlag('member_subscriptions');
    if (!tier || !member_subscriptions) {
        return null;
    }
    if (isOwner) {
        return React.createElement(WantMoreSubscribersTierUpsell, { className: className });
    }
    return isUserSubscribed ? (React.createElement(WantToSellTierUpsell, { className: className })) : (React.createElement(ExploreMoreTierUpsell, { className: className, authorName: (_b = deviation.author) === null || _b === void 0 ? void 0 : _b.username }));
};
TierUpsell.displayName = 'TierUpsell';
export default TierUpsell;
//# sourceMappingURL=TierUpsell.js.map